import {
  AmendedMotorcycleInput,
  AmendedPrivateInput,
  AmendedVanInput,
  calculateRegistrationFee as calculate, MotorcycleOutput,
  PrivateOutput,
  VanOutput
} from "@dmf/calculator-library";
import { CalculatedConstants, GenericConstants, RestOfConstants, ResultFields } from "@dmf/calculator-library/dist/registrationFee/types";

export type VersionYear = 2021 | 2022 | 2023 | 2024 | 2025 | 2026 | 2027

export type RegistrationFeeInput = {
  vehicleTypeId: number | null | undefined;
  versionYear: VersionYear | null | undefined;
  emissionValue: number | null | undefined;
  emissionUnitId: number | null | undefined;
  electricConsumption: number | null | undefined;
  electricRange: number | null | undefined;
  batteryCapacity: number | null | undefined;
  camperLivingArrangementCost: number | null | undefined;
  isHighWeight: boolean | null | undefined;
  isNew: true | false | null | undefined;
  taxableValue: number | null | null | undefined;
  tradePrice: number | null | null | undefined;
  newPrice: number | null | null | undefined;
};

export type RegistrationFeeOutput = {
  config?: Partial<CalculatedConstants> & Partial<RestOfConstants> & Partial<GenericConstants>;
  result?: Partial<ResultFields>
}
export const calculateRegistrationFee = (input: RegistrationFeeInput): RegistrationFeeOutput => {
  const calculator = getCalculator(input.vehicleTypeId);
  const result = calculator(input)
  const output = mapRegFeeResult(result, input)
  return output
}

const mapRegFeeResult = (
  output: MotorcycleOutput | PrivateOutput | VanOutput,
  input: RegistrationFeeInput
): RegistrationFeeOutput => {
  // switch (input.vehicleTypeId) {
  //     case 1: return mapPrivateOrVanOutput(output as PrivateOutput, input);
  //     case 2: return mapPrivateOrVanOutput(output as VanOutput, input);
  //     case 3: return mapMotorcycleOutput(output as MotorcycleOutput, input);
  //     default: return mapPrivateOrVanOutput(output as PrivateOutput, input);
  // }

  return {
    config: output.config,
    result: output.result,
  }
}


const mapEmissionUnit = (
  emissionUnitID: number | null | undefined
): AmendedPrivateInput['emissionUnit'] & AmendedVanInput['emissionUnit'] => {
  switch (emissionUnitID) {
    case 1: return "NEDC";
    case 3: return "NEDC2";
    default: return "WLTP"; // ID === 2
  }
}

const getCalculator = (
  vehicleTypeId: number | null | undefined
) => {
  switch (vehicleTypeId) {
    case 1: return calculatePrivate;
    case 2: return calculateVan;
    case 3: return calculateMotorCycle;
    default: return calculatePrivate;
  }
}

const mapIsNewRelatedInputs = (input: RegistrationFeeInput) => {
  return input.isNew ? {
    taxableValue: input.taxableValue || 0,
    newPrice: null,
    tradePrice: null,
  } : {
    newPrice: input.newPrice || 0,
    tradePrice: input.tradePrice || 0,
    taxableValue: null,
  };
}

const calculatePrivate = (input: RegistrationFeeInput): PrivateOutput => {
  const privateInput: AmendedPrivateInput = {
    vehicleType: "PRIVATE_VEHICLE",
    electricConsumption: input.electricConsumption || 0,
    electricRange: input.electricRange || 0,
    batteryCapacity: input.batteryCapacity || 0,
    emissionUnit: mapEmissionUnit(input.emissionUnitId),
    emissionValue: input.emissionValue || 0,
    isNew: input.isNew ?? false,
    versionYear: (input.versionYear ?? new Date().getFullYear()) as AmendedPrivateInput['versionYear'],
    ...mapIsNewRelatedInputs(input),
  }
  return calculate(privateInput)
}
const calculateVan = (input: RegistrationFeeInput): VanOutput => {
  const vanInput: AmendedVanInput = {
    vehicleType: "VAN",
    versionYear: (input.versionYear ?? new Date().getFullYear()) as AmendedPrivateInput['versionYear'],
    isHighWeight: input.isHighWeight || false,
    electricConsumption: input.electricConsumption || 0,
    electricRange: input.electricRange || 0,
    batteryCapacity: input.batteryCapacity || 0,
    emissionUnit: mapEmissionUnit(input.emissionUnitId),
    emissionValue: input.emissionValue || 0,
    isNew: input.isNew ?? false,
    ...mapIsNewRelatedInputs(input),
  }
  return calculate(vanInput)
}

const calculateMotorCycle = (input: RegistrationFeeInput): MotorcycleOutput => {
  const mcInput: AmendedMotorcycleInput = {
    vehicleType: "MOTORCYCLE",
    isElectric:
      input.emissionValue === 0 ||
      input.emissionValue === null ||
      input.emissionValue === undefined,
    versionYear: (input.versionYear ?? new Date().getFullYear()) as AmendedPrivateInput['versionYear'],
    isNew: input.isNew ?? false,
    ...mapIsNewRelatedInputs(input),
  }
  return calculate(mcInput)
}
